import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { WhatsAppFloat } from "./WhatsAppFloat";
import { useLang } from "@/context/LanguageContext";
import { WHATSAPP_ENABLED } from "@/data/copy";
import { useReducedMotion } from "@/hooks/useReducedMotion";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, lenis]);
  return null;
};

export const Layout = () => {
  const { t } = useLang();
  const reduced = useReducedMotion();

  return (
    <ReactLenis
      root
      options={{ lerp: 0.09, smoothWheel: !reduced, smoothTouch: false }}
    >
      <ScrollToTop />
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:start-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-forest focus:px-5 focus:py-3 focus:text-sm focus:font-semibold focus:text-cream"
      >
        {t.nav.skipToContent}
      </a>
      <Navbar />
      <main id="main" className="min-h-screen">
        <Outlet />
      </main>
      <Footer />
      {WHATSAPP_ENABLED && <WhatsAppFloat />}
    </ReactLenis>
  );
};
